<template>
  <agent-default>
    <pa-finalization-page :quote-id="quoteId" channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import PaFinalizationPage from '@/components/pa/PaFinalizationPage';

export default {
  name: 'AgentPaFinalization',
  components: { AgentDefault, PaFinalizationPage },
  props: ['quoteId'],
  metaInfo: { title: 'Students PA — Complete' },
};
</script>
